import { Plus, X } from "lucide-react";

export const ListEditor = ({ label, items = [], onChange, testid, placeholder = "Add item" }) => {
  const set = (i, v) => onChange(items.map((x, j) => (j === i ? v : x)));
  return (
    <div data-testid={testid}>
      <div className="cc-eyebrow mb-2">{label} <span className="text-slate-600">({items.length})</span></div>
      <div className="space-y-2">
        {items.map((it, i) => (
          <div key={i} className="flex gap-2">
            <input data-testid={`${testid}-item-${i}`} className="cc-input" value={it} placeholder={placeholder} onChange={(e) => set(i, e.target.value)} />
            <button type="button" data-testid={`${testid}-remove-${i}`} onClick={() => onChange(items.filter((_, j) => j !== i))} className="cc-btn cc-btn-ghost px-2.5"><X className="h-4 w-4" /></button>
          </div>
        ))}
        <button type="button" data-testid={`${testid}-add`} onClick={() => onChange([...items, ""])} className="flex items-center gap-1.5 text-xs text-emerald-400 transition-colors hover:text-emerald-300">
          <Plus className="h-3.5 w-3.5" /> Add
        </button>
      </div>
    </div>
  );
};

export const TestimonialsEditor = ({ items = [], onChange, onImport, importing }) => {
  const set = (i, k, v) => onChange(items.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
  return (
    <div data-testid="profile-testimonials-editor">
      <div className="mb-3 flex items-center justify-between">
        <div className="cc-eyebrow">Testimonials: real only <span className="text-slate-600">({items.length})</span></div>
        <button type="button" data-testid="profile-testimonials-import" onClick={onImport} disabled={importing} className="cc-btn cc-btn-ghost px-3 py-1.5 text-xs">{importing ? "Importing…" : "Import from website"}</button>
      </div>
      <div className="grid gap-3 md:grid-cols-2">
        {items.map((t, i) => (
          <div key={i} className="rounded-md border border-[#1e293b] bg-[#0a101d] p-4">
            <textarea data-testid={`profile-testimonial-quote-${i}`} rows={3} className="cc-input resize-y" value={t.quote || ""} placeholder="Exact quote" onChange={(e) => set(i, "quote", e.target.value)} />
            <div className="mt-2 flex gap-2">
              <input data-testid={`profile-testimonial-author-${i}`} className="cc-input" value={t.author || ""} placeholder="Name as shown" onChange={(e) => set(i, "author", e.target.value)} />
              <button type="button" data-testid={`profile-testimonial-remove-${i}`} onClick={() => onChange(items.filter((_, j) => j !== i))} className="cc-btn cc-btn-ghost px-2.5"><X className="h-4 w-4" /></button>
            </div>
            {(t.source || t.service) && <div className="mt-2 truncate font-mono text-[10px] text-slate-600">{t.source}{t.service ? ` · tag: ${t.service}` : ""}</div>}
          </div>
        ))}
      </div>
      <button type="button" data-testid="profile-testimonial-add" onClick={() => onChange([...items, { quote: "", author: "" }])} className="mt-3 flex items-center gap-1.5 text-xs text-emerald-400 hover:text-emerald-300"><Plus className="h-3.5 w-3.5" /> Add testimonial</button>
    </div>
  );
};

export const ServicesEditor = ({ items = [], onChange }) => {
  const set = (i, k, v) => onChange(items.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
  return (
    <div data-testid="profile-services-editor">
      <div className="cc-eyebrow mb-3">Services <span className="text-slate-600">({items.length})</span></div>
      <div className="grid gap-3 md:grid-cols-2">
        {items.map((s, i) => (
          <div key={i} className="rounded-md border border-[#1e293b] bg-[#0a101d] p-4">
            <div className="flex gap-2">
              <input data-testid={`profile-service-name-${i}`} className="cc-input font-semibold" value={s.name || ""} placeholder="Service name" onChange={(e) => set(i, "name", e.target.value)} />
              <button type="button" data-testid={`profile-service-remove-${i}`} onClick={() => onChange(items.filter((_, j) => j !== i))} className="cc-btn cc-btn-ghost px-2.5"><X className="h-4 w-4" /></button>
            </div>
            <textarea data-testid={`profile-service-desc-${i}`} rows={3} className="cc-input mt-2 resize-y" value={s.description || ""} placeholder="Description" onChange={(e) => set(i, "description", e.target.value)} />
            {s.page_url && <div className="mt-2 truncate font-mono text-[10px] text-slate-600">{s.page_url}</div>}
          </div>
        ))}
      </div>
      <button type="button" data-testid="profile-service-add" onClick={() => onChange([...items, { name: "", description: "" }])} className="mt-3 flex items-center gap-1.5 text-xs text-emerald-400 transition-colors hover:text-emerald-300">
        <Plus className="h-3.5 w-3.5" /> Add service
      </button>
    </div>
  );
};
